import React, { useEffect, useState } from 'react';
import LoadingSpinner from '../../../components/common/LoadingSpinner';
import { getReportsDashboard } from '../../../services/reportsService';

const SalesDashboard = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const result = await getReportsDashboard();
        setData(result);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  if (loading) return <LoadingSpinner />;
  if (!data) return <div className="text-gray-500">No data</div>;

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-gray-900">Sales Dashboard</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        <div className="card p-6">
          <div className="text-gray-500 text-sm">Total Revenue</div>
          <div className="text-2xl font-semibold">KSh {(data.totalRevenue || 0).toFixed(2)}</div>
        </div>
        <div className="card p-6">
          <div className="text-gray-500 text-sm">Pending Jobs</div>
          <div className="text-2xl font-semibold">{data.pendingJobs || 0}</div>
        </div>
        <div className="card p-6">
          <div className="text-gray-500 text-sm">Daily Sales</div>
          <div className="text-2xl font-semibold">KSh {(data.dailyTotals?.totalSales || 0).toFixed(2)}</div>
        </div>
      </div>
    </div>
  );
};

export default SalesDashboard;
